import type { SearchBoxTriggerStyles } from '../styles';
import { SvgIconSearchButton } from '../svg/icon-search-button';

export type SearchBoxTriggerProps = {
  styles: SearchBoxTriggerStyles;
  placeholderText?: string;
};

export default function SiteSearchBoxTrigger({ styles, placeholderText, ...props }: SearchBoxTriggerProps) {
  return (
    <button className={styles.base} {...props}>
      <div className={styles.box}>
        <span className={styles.input}>{placeholderText}</span>
      </div>
      <div className={styles.button}>
        <SvgIconSearchButton width={18} height={19} />
      </div>
    </button>
  );
}
